export default __webpack_public_path__ + "static/Prologue_Image_400x650px-47542c49c44fa10d45dbf3be3a0a089d.png";